export function resizeTextarea (ev) {
    var target = ev.target || ev;
    window.setTimeout(() => {
        target.style.height = 'auto';
        target.style.height = target.scrollHeight + 'px';
    }, 0);
}

export function resizeAllTextarea () {
    var textareas = document.getElementsByTagName("textarea");
    for (var i = 0; i < textareas.length; i++) {
        resizeTextarea(textareas[i]);
    }
}

export function checkListElementCompleteness (el) {
    let completeFlag = false;

    el.children.forEach((child) => {
        const childFlag = nodeChildCompleteCheck(child);

        if (childFlag) completeFlag = true;
    });

    return completeFlag;
}

function nodeChildCompleteCheck(el) {
    let completeFlag = false;

    if (el.type !== 'RADIO' && hasValue(el)) {
      completeFlag = true;
    } else if (el.children.length > 0) {
      if (el.type === 'GROUP_RADIO' && typeof el.value !== 'undefined') {
        return true;
      }
      el.children.forEach((ele) => {
        const childFlag = nodeChildCompleteCheck(ele);
        if (childFlag) completeFlag = true;
      });
    }

    return completeFlag;
}

function hasValue(el) {
    if (typeof el.value !== 'undefined') {
        if (el.type === 'CHECKBOX' && (el.value === 0 || el.value === '0')) {
            return false;
        }
        if (el.type === 'MULTILINE' && (el.value === '' || el.value === null)) {
            return false;
        }
        if (el.type === 'TEXT' && (el.value === '' || el.value === null)) {
            return false;
        }
        return true;
    }
    return false;
}


// WEBPACK FOOTER //
// ./src/app-func.js